<template>
   <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Author', to: '/author' },
      { label: 'Edit' }
    ]" title="Edit Author" />

    <div class="bg-white p-4">
      <form @submit.prevent="onSubmit">
        <div class="flex-col w-1/2 px-0 py-0">
        <label class="block font-medium mb-3 text-gray-700">Author Image (Optional)</label>
        <div
          class="relative w-36 h-36 border-2 parent-img-author border-dashed bg-gray-100 border-gray-300 rounded-lg flex items-center justify-center cursor-pointer hover:bg-gray-50"
         >
          <input ref="fileInput" type="file" accept="image/*" class="hidden"  @change="handleFileChange"/>
          <div v-if="imageFile" class="absolute inset-0">

            <img v-if="imageFile" :src="imageFile" alt="Author Image" class="object-cover w-full h-full rounded-lg" />
            <div class="image-author flex justify-end relative">
              
                <div  @click="triggerFileUpload" class="absolute bottom-3 right-12 bg-white text-red-500 rounded-full py-1.5 px-1.5 hover:bg-gray-100 flex" >
                  <div >
                  <svg class="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" d="M14 4.182A4.136 4.136 0 0 1 16.9 3c1.087 0 2.13.425 2.899 1.182A4.01 4.01 0 0 1 21 7.037c0 1.068-.43 2.092-1.194 2.849L18.5 11.214l-5.8-5.71 1.287-1.31.012-.012Zm-2.717 2.763L6.186 12.13l2.175 2.141 5.063-5.218-2.141-2.108Zm-6.25 6.886-1.98 5.849a.992.992 0 0 0 .245 1.026 1.03 1.03 0 0 0 1.043.242L10.282 19l-5.25-5.168Zm6.954 4.01 5.096-5.186-2.218-2.183-5.063 5.218 2.185 2.15Z" clip-rule="evenodd"/>
                  </svg>

                </div>
                </div>
                <div class="absolute bottom-3 right-2 bg-white text-red-500 rounded-full py-1.5 px-1.5 hover:bg-gray-100 flex" >
                  <button 
                        @click.stop="removeImage" title="Remove image">
                        <svg class="w-5 h-5 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                          <path fill-rule="evenodd" d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z" clip-rule="evenodd"/>
                        </svg>
                   </button>
               </div>
            </div>
           
          </div>

          <div v-else class="flex justify-center flex-col text-center align-middle items-center text-gray-400"  @click="triggerFileUpload">
            <svg class="w-6 h-6 text-gray-500 text-center dark:text-white" aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v6.41A7.5 7.5 0 1 0 10.5 22H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M9 16a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1Z"
                clip-rule="evenodd" />
            </svg>
            <p class="text-sm text-gray-500 m-0">Upload Image</p>
            <p class="text-xs text-gray-400 m-0">Max 2MB</p>
          </div>
        </div>
        <p v-if="errorMessageFile" class="text-red-500 text-sm mt-1">{{ errorMessageFile }}</p>
        <label class="block  mt-3 mb-3 font-medium text-gray-700">Author Name</label>
        <input 
        id="name" 
        type="text" 
        v-model="form.name" 
        placeholder="Enter Author Name" 
        :class="[
      'w-full rounded-md px-4 py-2.5 mb-3 text-sm focus:outline-none focus:ring-2',
      submitted && !form.name ? 'bg-red-300 focus:ring-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
    ]" />
    <p v-if="submitted && !form.name" class="text-red-500 text-sm mt-0">Must be filled.</p>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label class="block  mt-0 mb-3  font-medium text-gray-700">First Name (Optional)</label>
                <input
              id="name"
              type="text"
              v-model="form.first_name"
              placeholder="Enter First Name"
              :class="[
                'w-full rounded-md px-4 border py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2',
              ]"
            />
              </div>
              <!-- ... -->
              <div>
                <label class="block  mt-0 mb-3  font-medium text-gray-700">Last Name (Optional)</label>
                <input
              id="name"
              type="text"
              v-model="form.last_name"
              placeholder="Enter Last Name"
              :class="[
                'w-full rounded-md border px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2',
              ]"
            />
              </div>
              <div>
                <label class="block mt-0 mb-3 font-medium text-gray-700">Academic Title (Optional)</label>
                <input
              id="name"
              type="text"
              v-model="form.academic_title"
              placeholder="Enter Academic Title"
              :class="[
                'w-full rounded-md border px-4 py-2.5 bg-gray-50 text-sm focus:outline-none focus:ring-2',
              ]"
            />
              </div>
              <div>
                <label class="block mt-0 font-medium text-gray-700">Birth Date (Optional)</label>
                <DatetimeCustom :timeDate="false" class="mt-2 w-full mr-1.5" :label="''" v-model="form.birthdate"></DatetimeCustom>
              </div>
            </div>
            <label class="block  mt-3 mb-3 font-medium text-gray-700">Description (Optional)</label>
            <textarea
          v-model="form.meta"
          id="coupon-description"
          placeholder="Enter description about author..."
          rows="4"
          class="bg-gray-50 py-2.5 px-2 border h-36 rounded-lg w-full"
        ></textarea>
        <label class="text-gray-600 text-sm font-semibold mb-3 mt-3 block">Status</label>
            <div>
              <button clas type="button" @click="toggleActive" :class="{
                  'bg-blue-700': form.isActive,
                  'bg-gray-300': !form.isActive
                }" class="w-12 h-6 button-active-inactive rounded-full relative transition-colors duration-200 focus:outline-none">
                              <span :class="{
                  'translate-x-6': form.isActive,
                  'translate-x-0': !form.isActive
                }" class="w-5 h-5 bg-white rounded-full shadow transform transition-transform duration-200"></span>
              </button>
            </div>
      </div>
      <div class="flex items-center space-x-4 mt-3">
            <button type="submit"
              class="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-3 py-2 rounded-md">
              Save
            </button>
            <button type="button" @click="$router.push('/author')"
              class="border border-gray-300 text-gray-700 text-sm font-medium px-3 py-2 rounded-md hover:bg-gray-50">
              Cancel
            </button>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { AuthorPath } from '../../router/content';
import constant from "../../store/constant";
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import DatetimeCustom from '@/components/form/Datetime.vue'
import {EventBus} from '../../event-bus'
export default {
  components: {
    HeaderBreadcrumbs,
    DatetimeCustom
  },
  data() {
    return {
      id: null,
      title: '',
      submitted :false,
      imageFile: null,
      errorMessageFile:null,
      form: {
        name: null,
        slug: null,
        isActive: false,
        birthdate: null,
        first_name: null,
        last_name: null,
        profile_pic_url:null,
        academic_title: null,
        meta: null,
        preview: null,
        image: null,
        file: null,
      },
      AuthorPath,
    }
  },
  created() {
    const id = this.$route.params.id;
    this.id = id;
    this.fetchAuthorByID({ id });
  },
  computed: {
    ...mapGetters('author', ['author']),
    ...mapState({
      isLoading: (state) => state.author.isLoading,
      isError: (state) => state.author.isError,
      errorMessage: (state) => state.author.errorMessage,
      successMessage: (state) => state.author.successMessage,
    }),
  },
  watch: {
    errorMessage: function (message) {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
            message:message,
            type: 'success',
          });
    },
    successMessage: function (message) {
      if (!this.successMessage) return;
      console.log(message)
    //  this.messageAlert('success', message);
      EventBus.$emit('show-toast', {
            message:'Author has been updated.',
            type: 'success',
          });
      this.$router.push(this.AuthorPath);
    },
    author: function (data) {
      if (!data) return;
      this.title = data.name;
      this.form.name = data.name;
      this.form.slug = data.slug;
      this.form.isActive = data.is_active;
      this.form.birthdate = data.birthdate;
      this.form.first_name = data.first_name;
      this.form.last_name = data.last_name;
      this.form.academic_title = data.academic_title;
      this.form.meta = data.meta;
      // const baseImgUrl = process.env.NODE_ENV === "development" ? constant.IMG_URL_STATIC_AUTHOR_STAGING.URL : constant.IMG_URL_STATIC_AUTHOR.URL;
      this.imageFile = data.profile_pic_url ? constant.IMG_URL_STATIC_AUTHOR.URL + data.profile_pic_url : null;
      this.form.profile_pic_url = data.profile_pic_url || null
      },
    },
  methods: {
    ...mapActions('author', [
      'updateAuthor',
      'fetchAuthorByID',
      'uploadImage',
    ]),
    onSubmit(event) {
      event.preventDefault();
      this.form.id = this.id;
      this.submitted = true;
      if (!this.form.name ) return; 
      this.updateAuthor(this.form);
    },
    previewImage: function(event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.form.preview = e.target.result;
        }
        this.form.image=input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (!file.type.startsWith('image/')) {
        this.errorMessageFile = 'Only image files are allowed.';
        return;
      }

      if (file.size > 2 * 1024 * 1024) {
        this.errorMessageFile = 'Image size must be less than 2MB.';
        return;
      }

      this.errorMessageFile = '';
      this.imageFile = URL.createObjectURL(file)
      this.form.file = file
    },
    removeImage() {
      this.form.file = null;
      this.form.profile_pic_url = null
      this.imageFile = null;
      this.$refs.fileInput.value = '';
    },
    toggleActive() {
      this.form.isActive = !this.form.isActive;
    },
    onUpload(e) {
      e.preventDefault();
      if (!this.form.image) {
        this.messageAlert('error', 'Please select file to upload');
        return;
      }
      this.uploadImage({
        id: this.id,
        image: this.form.image,
      });
    },
    messageAlert(icon, title, timer = 3000) {
      this.$swal({
        toast: "true",
        position: "top-end",
        icon,
        title,
        showConfirmButton: false,
        timer,
        timerProgressBar: true,
      });
    },
  }
}
</script>
<style>
.button-active-inactive {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.parent-img-author .image-author {
  display: none;
}
.parent-img-author:hover .image-author {
  background: #11192880;
  z-index: 1000;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  display: block;
}
</style>